import React from 'react';
import { Dimensions, Image, StyleSheet, TouchableOpacity, View } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import { CourseGroupV2, CourseStatus, CourseV2 } from '../api/models/Course';
import { dimensions, scale } from '../Styles';
import { getCourseColor, getNeededCourseColor } from '../util/CourseColor';
import { tileIndex } from '../util/TileIndex';

type CourseTileProps = {
  courseGroup: CourseGroupV2;
  course: CourseV2;
  onPress: () => void;
  /** override size of tile */
  size?: number;
};

export const MNOHSCourseTile: React.FC<CourseTileProps> = ({ courseGroup, course, size, onPress }) => {
  const tileIndexGroup = tileIndex[courseGroup.courseGroupCode];

  const isMobile = useMediaQuery({
    maxDeviceWidth: 576,
  });

  const { width } = Dimensions.get('window');
  const screenWidth = isMobile ? width : scale(dimensions.WEB_MAX_CONTAINER_WIDTH);
  const extraMargin = scale(2) * 16; // 2 is horizontal margin of each tile
  const boxSize = (screenWidth - (scale(40) + extraMargin)) / 9; // 40 is the horizontal margin of the parent container

  const _renderTile = () => {
    const doneBg = getCourseColor(courseGroup.courseGroupCode);
    const neededBg = getNeededCourseColor(courseGroup.courseGroupCode);

    if (course.status === CourseStatus.NEEDED) {
      return <View style={[styles.neededSquare, { backgroundColor: neededBg }]} />;
    }
    if (course.status === CourseStatus.DONE && course.isHonors) {
      return <Image source={tileIndexGroup.HONORS} style={styles.image} resizeMode={'contain'} />;
    }
    if (course.status === CourseStatus.DONE && !course.isHonors) {
      return <View style={[styles.doneSquare, { backgroundColor: doneBg }]} />;
    }

    let source;
    switch (course.status) {
      case CourseStatus.IN_PROGRESS:
        source = tileIndexGroup.IN_PROGRESS;
        break;
      case CourseStatus.PARTIAL:
        source = tileIndexGroup.PARTIAL;
        break;
    }

    return <Image source={source} style={styles.image} resizeMode={'contain'} />;
  };

  return (
    <TouchableOpacity
      disabled={true}
      style={[styles.imageWrapper, { height: size ?? boxSize, width: size ?? boxSize }]}
      activeOpacity={0.8}
      onPress={onPress}>
      {_renderTile()}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  image: {
    aspectRatio: 1 / 1,
    width: '100%',
    height: '100%',
  },
  imageWrapper: {
    marginHorizontal: scale(2),
    marginBottom: scale(4),
  },
  doneSquare: {
    width: '100%',
    height: '100%',
    aspectRatio: 1 / 1,
    borderRadius: 6,
  },
  neededSquare: {
    width: '100%',
    height: '100%',
    aspectRatio: 1 / 1,
    borderRadius: 6,
  },
});
